export class QueryKey {
  static users = '/users'
  static reservations = '/reservations'
  static stations = '/stations'
  static extras = '/extras'
  static headerLinks = '/header-links'
  static organizations = '/organizations'
  static infoWidgets = '/info-widgets'
}